export const etapasSolicitacaoEnum = {
    VAZIO: 0,

    // #region CLASSIFICAR
    AGUARDANDO_CLASSIFICACAO: 1,
    CLASSIFICACAO: 2,
    RECLASSIFICAR: 3,
    // #endregion

    // #region AJUSTAR
    SOLICITAR_AJUSTES_SOLICITACAO: 4,
    DOCUMENTACAO_PROCESSO: 5,
    CONFORMIDADE_LEGAL: 6,
    COMPLEMENTAR_DOCUMENTACAO: 7,
    AJUSTAR_EDITAL: 8,
    AJUSTAR_SOLICITACAO: 9,
    // #endregion

    // #region ANÁLISAR
    ANALISAR_TR: 10,
    ANALISAR_DOCUMENTACAO_DO_PROCESSO: 11,
    DOCUMENTACAO_DO_PROCESSOS_PRECISA_DE_AJUSTES: 12,
    // #endregion

    // #region INSTRUÇÃO
    INSTRUCAO_COTACAO: 13,
    DOCUMENTACAO_DA_EMPRESA: 14,
    DOCUMENTACAO_RECEBIDA: 15,
    // #endregion

    // #region ELABORAR
    ELABORAR_EDITAL: 16,
    ELABORAR_JUSTIFICATIVA: 17,
    // #endregion

    // #region VALIDAR
    VALIDAR_EDITAL: 18,
    TR_ENVIADO_PARA_ASSINATURA: 19,
    RECEBER_ASSINATURA: 20,
    FINALIZAR_EDITAL: 21,
    VALIDAR_JUSTIFICATIVA: 22,
    JUSTIFICATIVA_APROVADA: 23,
    // #endregion

    // #region PUBLICAR
    PUBLICAR_EDITAL: 24,
    // #endregion

    // #region SESSÃO PÚBLICA
    SESSAO_PUBLICA: 25,
    // #endregion

    // #region RECURSO
    RECURSO: 26,
    // #endregion

    // #region PARECER
    SOLICITAR_PARECER: 27,
    // #endregion

    // #region ANALISE JURIDICA
    ELABORAR_PARECER_JURIDICO: 28,
    ENCAMINHAR_PARA_ANALISE_JURIDICA_APRECIACAO: 29,
    PROCESSO_HOMOLOGADO: 30,
    SOLICITACAO_CANCELADA: 31,
    COMPROMETER_CONTRATACAO: 32,
    SOLICITACAO_FINALIZADA: 33,
    // #endregion
};
